<admin-app-header></admin-app-header>
<app-enterprise-admin-bar></app-enterprise-admin-bar>

<div class="map-page">
    <!-- Controls Bar -->
    <div class="controls-bar">
        <div class="controls-left">
            <h1><i class="fa-solid fa-map-location-dot"></i> Parking Map</h1>
            <span class="count-badge">{{ totalVisible | number }} of {{ totalAll | number }} parkings</span>
        </div>
        <div class="legend">
            <button
                *ngFor="let key of statusKeys"
                class="legend-btn"
                [class.legend-btn--inactive]="!statusConfig[key].visible"
                (click)="toggleStatus(key)"
            >
                <span class="legend-dot" [style.background-color]="statusConfig[key].color"></span>
                {{ statusConfig[key].label }}
                <span class="legend-count">({{ statusConfig[key].count }})</span>
            </button>
        </div>
    </div>

    <!-- Loading State -->
    <div class="loading-state" *ngIf="loading">
        <i class="fa-solid fa-spinner fa-spin"></i>
        <p>Loading parkings...</p>
    </div>

    <!-- Map -->
    <div class="map-container" *ngIf="!loading">
        <agm-map
            [latitude]="cameraLat"
            [longitude]="cameraLng"
            [zoom]="zoom"
            [scrollwheel]="true"
            [streetViewControl]="false"
            [mapTypeControl]="true"
            [styles]="mapStyles"
            (centerChange)="onCenterChange($event)"
            (zoomChange)="onZoomChange($event)"
            style="height: 100%"
        >
            <agm-marker
                *ngFor="let parking of displayParkings"
                [latitude]="parking.parkingLocation.latitude"
                [longitude]="parking.parkingLocation.longitude"
                [iconUrl]="iconUrlMap[parking.$key!]"
                (markerClick)="onMarkerClick(parking)"
            ></agm-marker>

            <agm-info-window
                *ngIf="selectedParking"
                [latitude]="selectedParking.parkingLocation.latitude"
                [longitude]="selectedParking.parkingLocation.longitude"
                [isOpen]="!!selectedParking"
                (infoWindowClose)="onInfoWindowClose()"
            >
                <div class="info-window">
                    <div class="info-header">
                        <h3>{{ selectedParking.title || 'Untitled Parking' }}</h3>
                        <span class="status-badge" [style.background-color]="getStatusColor(selectedParking)">
                            {{ getStatusLabel(selectedParking) }}
                        </span>
                    </div>
                    <div class="info-body">
                        <div class="info-row">
                            <i class="fa-solid fa-building"></i>
                            <span>{{ selectedParking.denormMerchantCompanyName || 'Unknown merchant' }}</span>
                        </div>
                        <div class="info-row">
                            <i class="fa-solid fa-location-dot"></i>
                            <span>{{ getAddress(selectedParking) }}</span>
                        </div>
                        <div class="info-row" *ngIf="selectedParking.numberOfBays">
                            <i class="fa-solid fa-square-parking"></i>
                            <span>{{ selectedParking.numberOfBays }} bay{{ selectedParking.numberOfBays !== 1 ? 's' : '' }}</span>
                        </div>
                        <div class="info-row" *ngIf="selectedParking.parkingType">
                            <i class="fa-solid fa-car"></i>
                            <span>{{ selectedParking.parkingType }}</span>
                        </div>
                    </div>
                    <div class="info-footer">
                        <a [href]="'/parking/' + selectedParking.$key" target="_blank" class="info-link">
                            <i class="fa-solid fa-arrow-up-right-from-square"></i> View Parking
                        </a>
                        <a *ngIf="getMerchantKey(selectedParking)" [routerLink]="['/merchant', getMerchantKey(selectedParking), 'parking', selectedParking.$key]" class="info-link info-link--secondary">
                            <i class="fa-solid fa-pen-to-square"></i> Edit Parking
                        </a>
                    </div>
                </div>
            </agm-info-window>
        </agm-map>
    </div>
</div>
